import { jsxs, jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import styles from '../../styles/uitk-egds-field.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSFieldMessage = props => {
  const {
    className,
    message,
    id,
    type
  } = props;
  const cssClassNames = getClassNameList(`uitk-field-message`, `uitk-field-message-${type}`, `uitk-${type}-message`, className);
  return jsxs(EGDSLayoutFlex, {
    space: "xsmall",
    alignItems: "center",
    className: cssClassNames,
    id: `${id}-${type}`,
    children: [type === 'error' && jsx(EGDSLayoutFlexItem, {
      alignSelf: "start",
      children: jsx(EGDSIcon, {
        name: "error_outline",
        size: EGDSIconSize.SMALL
      })
    }), message]
  });
};
export { EGDSFieldMessage };